import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Card from "../../components/Card/Card";
import { AssetsMiddleware } from "../../Store/Middlewares/AssetsMiddleware";
import { Table } from "antd";
import styles from "./style.module.css";
import { Dropdown, TextComponent } from "../../components";
import { FiSearch } from "react-icons/fi";
import AntdTab from "../../components/AntdTab/AntdTab";
import Switch from "../../components/Switch/Switch";
import { MdOutlineResetTv } from "react-icons/md";

const SharedAccess = () => {
  const [search, setSearch] = useState("");
  const [access, setAccess] = useState([]);
  const [activeTab, setActiveTab] = useState("temporary");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AssetsMiddleware.getDealerShareAccess(activeTab)).then((data) => {
      setAccess(data?.data?.data);
    });
  }, [activeTab]);

  const filteredLogs = useMemo(() => {
    return access?.filter((acc) => {
      if (!search) return true;
      delete acc?.id;
      delete acc?.customer_id;
      return Object.values(acc).some((value) => {
        if (value === null || value === undefined) return false;

        return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });
  }, [search, access]);

  const items = [
    {
      key: "temporary",
      label: "Temporary",
    },
    {
      key: "sold",
      label: "Sold",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent text={index + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : "/placeholder.png"}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.name ? data?.name : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.model ? data?.model : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Make",
      dataIndex: "make",
      key: "make",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.make ? data?.make : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Trim",
      dataIndex: "trim",
      key: "trim",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.trim ? data?.trim : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.color ? data?.color : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.vin_no ? data?.vin_no : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock_no",
      key: "stock_no",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.customer_name ? data?.customer_name : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Customer Email",
      dataIndex: "customer_email",
      key: "customer_email",
      render: (item, data) => (
        <div>
          <TextComponent
            text={data?.customer_email ? data?.customer_email : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
  ];

  const revoke = {
    title: "Revoke Access",
    dataIndex: "revoke",
    key: "revoke",
    render: (item, data) => (
      <div>
        <MdOutlineResetTv
          size={25}
          style={{ cursor: "pointer", color: "red" }}
          onClick={() =>
            dispatch(
              AssetsMiddleware.dealerRemoveAccess({
                assetId: data?.id,
                userId: data?.customer_id,
              }),
            ).then(() => {
              setAccess(filteredLogs?.filter((x) => x?.id !== data?.id));
            })
          }
        />
      </div>
    ),
  };

  return (
    <Card>
      <div className={styles.topcontrols}>
        <div className={styles.header}>
          <TextComponent
            text={"Shared Vehicle"}
            className={styles.headerHeading}
          />
          <div className={styles.rightHeader}>
            {/* <div className="flex-between"> */}
            <div className={styles.searchBox}>
              <FiSearch size={18} style={{ marginRight: 8 }} />
              <input
                className={styles.searchbox}
                type="text"
                placeholder="Search ..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <AntdTab
              ActiveTab={activeTab}
              setActiveTab={setActiveTab}
              items={items}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
      <div className={styles.tableDiv}>
        <Table
          scroll={{ x: true }}
          bordered={false}
          columns={activeTab === "temporary" ? [...columns, revoke] : columns}
          dataSource={filteredLogs}
        />
      </div>
    </Card>
  );
};

export default SharedAccess;
